import { useState, useEffect, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { graphicDataColor1, graphicDataColor2 } from "../../../../config/constants";
// Components
import Graphic from "../../../graphic";
import GraphicContainer from "../../../GraphicContainer";

const AreaCoveredPlot = forwardRef(({ recordings }, ref) => {
  const [positions, setPositions] = useState([]);
  const [areaLeftValues, setAreaLeftValues] = useState([]);
  const [areaRightValues, setAreaRightValues] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let positions = [];
    let area_hand_left = [];
    let area_hand_right = [];

    recordings.forEach((recording, i) => {
      positions.push(i + 1);
      area_hand_left.push(recording.hasOwnProperty("area_hand_left") ? recording.area_hand_left : NaN);
      area_hand_right.push(recording.hasOwnProperty("area_hand_right") ? recording.area_hand_right : NaN);
    });

    setPositions(positions);
    setAreaLeftValues(area_hand_left);
    setAreaRightValues(area_hand_right);

    return () => {
      setPositions([]);
      setAreaLeftValues([]);
      setAreaRightValues([]);
    };
  }, [recordings]);

  const areaData = {
    labels: positions,
    datasets: [
      {
        label: t("reports_areaCoveredGraphic_legend1"),
        data: areaLeftValues,
        backgroundColor: [graphicDataColor1],
        borderColor: [graphicDataColor1],
      },
      {
        label: t("reports_areaCoveredGraphic_legend2"),
        data: areaRightValues,
        backgroundColor: [graphicDataColor2],
        borderColor: [graphicDataColor2],
      },
    ],
  };

  return (
    <GraphicContainer ref={ref}>
      <Graphic
        Title={t("reports_areaCovered")}
        Type={Line}
        data={areaData}
        axisY={t("reports_areaCovered")}
        axisX={t("sessions")}
        graphicDescription={t("graphics_areaCoveredDescription_ClinicAndHome")}
      />
    </GraphicContainer>
  );
});

export default AreaCoveredPlot;
